export class PwdInput {
  visible: boolean;
  inputType: string;
  icon: string = CLOSE_EYE_ICON;
  bottomText: string = '';
  class: 'disabled' | 'error' | 'error-for-disable' | '' = '';

  constructor(isVisible: boolean = false) {
    this.visible = isVisible ? pwdInputState.shown.visibilityFlag : pwdInputState.hidden.visibilityFlag;
    this.inputType = isVisible ? pwdInputState.shown.inputType : pwdInputState.hidden.inputType;
  }

  switchState(): void {
    this.visible = !this.visible;
    if (this.visible) {
      this.inputType = pwdInputState.shown.inputType;
      this.icon = OPEN_EYE_ICON;
    } else {
      this.inputType = pwdInputState.hidden.inputType;
      this.icon = CLOSE_EYE_ICON;
    }
  }
}

const CLOSE_EYE_ICON = 'password-eye-closed.svg; icon-size-1em';
const OPEN_EYE_ICON = 'password-eye-opened.svg; icon-size-1em';

const pwdInputState = {
  shown: {
    visibilityFlag: true,
    inputType: 'text',
  },
  hidden: {
    visibilityFlag: false,
    inputType: 'password',
  },
};
